<template>
  <b-overlay :show="page_loader">
    <div class="users-style">
      <h4 class="atlhr-dashboard-title mt-10">
        {{ run_approved ? 'Approved' : 'Draft' }} Overtime Run for {{ month_label }}<b-icon icon="check-circle-fill" variant="success" v-if="run_approved"></b-icon>
        <span>
          <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a>
          / <a v-bind:href="$api_url + '/leave-attendance/overtime'">Overtime Runs</a>
          / Review Overtime
        </span>
      </h4>

      <div class="ibox mt-3 p-4">
        <div class="row mt-2 mb-2">
          <div class="col-md-12">
            <div class="d-flex justify-content-end align-items-center flex-wrap">

              <template v-if="run_approved === true">
                <b-button size="sm" class="mr-2 mb-2" :disabled="loading" @click="confirmRevert">
                  <b-icon icon="skip-backward" class="mr-1"></b-icon>
                  Revert to Draft
                </b-button>
              </template>

              <template v-if="run_approved === false">

                <b-button :disabled="loading" class="mb-2 mr-2 btn-approved" href="javascript:void(0);"
                  @click="confirmApprove()">
                  <b-icon icon="check-circle-fill" class="mr-2" scale="1"></b-icon>Approve Run
                </b-button>

                <button class="btn btn-delete px-3 py-2 mb-2 mr-2 font-semi-bold" :disabled="loading" @click="confirmDeleteRun">
                  <b-icon icon="trash" class="mr-1"></b-icon>
                  Delete Run
                </button>

                <b-button size="sm" variant="primary" class="mr-2 mb-2" @click="draftOvertime(null, 1)">
                  Give Payment Approval To All Records For Selected Employees
                </b-button>

              </template>

              <a class="btn btn-sm btn-primary mb-2 text-light" :href="$api_url + '/leave-attendance/overtime'">
                <i class="fa fa-arrow-left mr-1" aria-hidden="true"></i>
                Back to List
              </a>

            </div>
          </div>
        </div>

        <div v-if="error_msg != ''" class="alert alert-danger" role="alert">
          {{ error_msg }}
        </div>

        <div v-else>
          <common-list :pageurl="$api_url" :checkbox="run_approved ? 0 : 1" :is_action="1" :appended_column="appended_column"
            :key="list_key" :company_options="company_options" :employees="list_rows" :default_column="default_column"
            :primary_key="'overtime_id'" :all_employee="'no'" v-on:childToParent="listReturn"></common-list>
        </div>
      </div>

      <b-modal id="overtime-detail-preview-modal" size="xxl" centered hide-footer>
        <template #modal-title>
          <div class="mb-0">
            <h5 class="mb-1">Overtime Details</h5>
            <small class="text-muted mb-0">
              {{ run_approved ? 'Read-only preview of daily overtime records.' : 'Review daily overtime records and give approval for payment if needed.' }}
            </small>
          </div>
        </template>

        <roster-overtime-details :can_edit="true && !run_approved" :row="selectedDetailRow" @reloadData="fetchOvertimes"></roster-overtime-details>
      </b-modal>
      <b-modal id="overtime-policy-modal" size="lg" centered hide-footer>
        <template #modal-title>
          <h5 class="mb-0">OT Policy — {{ selectedPolicyEmployee }}</h5>
        </template>

        <div v-if="selectedPolicy" class="p-3">

          <div class="row mb-3 pb-2 border-bottom">
            <div class="col-md-4 mb-2">
              <strong>Policy Name:</strong> {{ selectedPolicy.name || '-' }}
            </div>
            <div class="col-md-4 mb-2">
              <strong>Min Requirement for OT:</strong> {{ selectedPolicy.min_minute ?? 0 }} mins
            </div>
            <div class="col-md-4 mb-2">
              <strong>Max Allowed OT:</strong> {{ parseInt(selectedPolicy.max_hours) || 0 }} hrs per {{ selectedPolicy.max_limit_type == 1 ? 'month' : 'day' }}
            </div>
          </div>

          <div class="row mb-3 pb-2 border-bottom">
            <div class="col-md-4 mb-2">
              <strong>OT Calculation Type:</strong> {{ selectedPolicy.ot_on == 1 ? 'Fixed Amount' : 'Salary Based' }}
            </div>
            <div class="col-md-4 mb-2" v-if="selectedPolicy.ot_on == 1">
              <strong>Fixed Amount:</strong> {{ selectedPolicy.fixed_amount }} Taka
            </div>
            <div class="col-md-4 mb-2" v-else>
              <strong>Calculate on:</strong> {{ selectedPolicy.calculate_on == 1 ? 'Gross' : 'Basic' }} Salary
            </div>
            <div class="col-md-4 mb-2">
              <strong>Cumulative OT:</strong> {{ selectedPolicy.cumu_over_under == 1 ? 'Before & After Shift' : 'After Shift Only' }}
            </div>
          </div>

          <div class="row mb-3 pb-2 border-bottom">
            <div class="col-md-4 mb-2">
              <strong>Calculate From Exact Punch-Time:</strong> {{ selectedPolicy.from_settings_in == 1 ? 'Yes' : 'No' }}
            </div>
            <div class="col-md-4 mb-2">
              <strong>Hours Required On Week Off / Holidays:</strong> {{ selectedPolicy.credit_hour_holiday ?? 0 }} hrs
            </div>
            <div class="col-md-4 mb-2">
              <strong>Tax Status:</strong> {{ selectedPolicy.taxable == 1 ? 'Taxable' : 'Non-Taxable' }}
            </div>
          </div>

          <div v-if="selectedPolicy.taxable == 1" class="row mb-3 pb-2 border-bottom">
            <div class="col-md-6 mb-2">
              <strong>Tax Deduction:</strong> {{ selectedPolicy.tax_over_fy == 1 ? 'Allocate Tax over Fiscal Year' : 'Deduct Effective Tax up-front' }}
            </div>
          </div>

          <table class="table table-bordered text-center mb-3">
            <thead class="table-head">
              <tr>
                <th class="text-left">Day Type</th>
                <th>Compensatory Leave Ratio</th>
                <th>Overtime Pay Ratio</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-left">Regular Work Day</td>
                <td>{{ selectedPolicy.rate_regular_leave ?? 0 }}</td>
                <td>{{ selectedPolicy.rate_regular_salary ?? 0 }}</td>
              </tr>
              <tr>
                <td class="text-left">Weekend</td>
                <td>{{ selectedPolicy.rate_weekend_leave ?? 0 }}</td>
                <td>{{ selectedPolicy.rate_weekend_salary ?? 0 }}</td>
              </tr>
              <tr>
                <td class="text-left">Holiday</td>
                <td>{{ selectedPolicy.rate_holiday_leave ?? 0 }}</td>
                <td>{{ selectedPolicy.rate_holiday_salary ?? 0 }}</td>
              </tr>
            </tbody>
          </table>

          <table class="table table-bordered text-center mb-0">
            <thead class="table-head">
              <tr>
                <th class="text-left">Payment Policy</th>
                <th v-if="selectedPolicy.rate_regular_leave > 0 || selectedPolicy.rate_regular_salary > 0">Regular Day</th>
                <th v-if="selectedPolicy.rate_weekend_leave > 0 || selectedPolicy.rate_weekend_salary > 0">Weekend</th>
                <th v-if="selectedPolicy.rate_holiday_leave > 0 || selectedPolicy.rate_holiday_salary > 0">Holiday</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-left">Specified Days (0 for Days In Month)</td>
                <td v-if="selectedPolicy.rate_regular_leave > 0 || selectedPolicy.rate_regular_salary > 0">{{ selectedPolicy.regular_days ?? 0 }}</td>
                <td v-if="selectedPolicy.rate_weekend_leave > 0 || selectedPolicy.rate_weekend_salary > 0">{{ selectedPolicy.weekend_days ?? 0 }}</td>
                <td v-if="selectedPolicy.rate_holiday_leave > 0 || selectedPolicy.rate_holiday_salary > 0">{{ selectedPolicy.holiday_days ?? 0 }}</td>
              </tr>
              <tr>
                <td class="text-left">Custom Hours (0 for Actual Duty Time)</td>
                <td v-if="selectedPolicy.rate_regular_leave > 0 || selectedPolicy.rate_regular_salary > 0">{{ selectedPolicy.regular_hour ?? 0 }}</td>
                <td v-if="selectedPolicy.rate_weekend_leave > 0 || selectedPolicy.rate_weekend_salary > 0">{{ selectedPolicy.weekend_hour ?? 0 }}</td>
                <td v-if="selectedPolicy.rate_holiday_leave > 0 || selectedPolicy.rate_holiday_salary > 0">{{ selectedPolicy.holiday_hour ?? 0 }}</td>
              </tr>
            </tbody>
          </table>

        </div>
        <div v-else class="text-muted text-center py-3">No policy data available.</div>
      </b-modal>

      <b-modal id="overtime-approve-password-modal" title="Confirm Password" centered hide-footer>
        <p class="mb-2">Enter your password to approve this overtime run.</p>
        <b-form-input type="password" v-model="approve_password" placeholder="Password"
          autocomplete="current-password"></b-form-input>
        <div v-if="approve_error" class="text-danger small mt-2">{{ approve_error }}</div>
        <b-button class="w-100 my-2" @click="submitApprove">Approve</b-button>
        <b-button class="w-100" @click="$bvModal.hide('overtime-approve-password-modal')">Cancel</b-button>
      </b-modal>
      <b-modal id="overtime-revert-password-modal" title="Confirm Password" centered hide-footer>
        <p class="mb-2">Enter your password to revert this overtime run to draft.</p>
        <b-form-input type="password" v-model="approve_password" placeholder="Password"
          autocomplete="current-password"></b-form-input>
        <div v-if="approve_error" class="text-danger small mt-2">{{ approve_error }}</div>
        <b-button class="w-100 my-2" @click="submitRevert">Revert to Draft</b-button>
        <b-button class="w-100" @click="$bvModal.hide('overtime-revert-password-modal')">Cancel</b-button>
      </b-modal>

      <b-modal id="overtime-run-delete-password-modal" title="Confirm Password" centered hide-footer>
        <p class="mb-2">Enter your password to delete this overtime run.</p>
        <b-form-input type="password" v-model="approve_password" placeholder="Password"
          autocomplete="current-password"></b-form-input>
        <div v-if="approve_error" class="text-danger small mt-2">{{ approve_error }}</div>
        <b-button class="w-100 my-2" variant="primary" :disabled="loading" @click="submitDeleteRun">Delete</b-button>
        <b-button class="w-100" @click="$bvModal.hide('overtime-run-delete-password-modal')">Cancel</b-button>
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
export default {
  props: ['run_id'],
  data() {
    return {
      page_loader: true,
      error_msg: '',
      overtimes: [],
      selectedOvertimeRows: [],
      year: '',
      month: '',
      month_label: '',
      run_approved: null,
      loading: false,
      approve_password: '',
      approve_error: '',
      daytypes: ['Hourly', 'Off Day', 'Holiday'],
      overtimeDetails: [],
      selectedDetailRow: null,
      selectAllFinal: false,
      detail_loading: false,
      delete_ids: [],
      list_key: 0,
      list_rows: [],
      selectedPolicy: null,
      selectedPolicyEmployee: '',
      company_options: [],
      employee_map: {},
      default_column: ['name', 'employee_code', 'department', 'jobposition'],
      appended_column: [
        { value: 'attendance_from', text: 'From', type: 'text' },
        { value: 'attendance_to', text: 'To', type: 'text' },
        { value: 'final_count', text: 'Eligible OT Days', type: 'text' },
        { value: 'salary_days', text: 'Salary Benefit Days', type: 'text' },
        { value: 'p_overtime', text: 'Suggested Overtime', type: 'text' },
        { value: 'salary_hours', text: 'Salary Hours', type: 'text' },
        { value: 'salary_type', text: 'Salary Type', type: 'text' },
      ],
    }
  },
  mounted() {
    this.fetchOvertimes();
  },
  methods: {

    buildListRows() {
      this.list_rows = this.overtimes.map(row => {
        const employee = this.employee_map[row.employee_id] || { pic: '', company_id: '' };
        const actions = [
          { label: this.run_approved ? 'Preview' : 'Preview and Edit', value: 1 },
          { label: 'View Policy', value: 2 },
        ];

        return {
          ...employee,
          policy: row.policy,
          overtime_id: row.id,
          employee_id: row.employee_id,
          name: row.name,
          employee_code: row.employee_code,
          attendance_from: row.attendance_from,
          attendance_to: row.attendance_to,
          final_count: row.final_count,
          salary_days: row.salary_days,
          salary_hours: (row.salary_minutes / 60).toFixed(2),
          p_overtime: (row.p_overtime / 60).toFixed(2),
          salary_type: row.salary_type,
          locked: row.leave_settled == 1 ? 1 : 0,
          actions: actions,
        };
      });
      this.list_key++;
    },
    showPolicy(row) {
      this.selectedPolicyEmployee = row.name + ' (' + row.employee_code + ')';
      this.selectedPolicy = JSON.parse(row.policy);
      this.$bvModal.show('overtime-policy-modal');
    },

    listReturn(data) {
      if (data.selected && data.selected.length > 0) {
        this.selectedOvertimeRows = data.selected;
        return;
      }

      this.selectedOvertimeRows = [];
      const row = this.overtimes.find(item => item.id == data.overtime_id);
      if (!row) return;

      if (data.action_id == 1 || data.action_id == 0) {
        this.openDetailModal(row);
      }
      if (data.action_id == 2) {
        this.showPolicy(row);
        return;
      }
    },

    fetchEmployees() {
      return axios.get(this.$api_url + '/employee/list').then((response) => {
        const map = {};
        (response.data.employee_data || []).forEach(employee => { map[employee.employee_id] = employee; });
        this.employee_map = map;
        this.company_options = response.data.options || [];
      }).catch(() => {
        this.company_options = [{ label: 'name' }, { label: 'employee_code' }];
      });
    },

    fetchOvertimes() {
      this.page_loader = true;
      let formData = new FormData();
      formData.append('run_id', this.run_id);

      const runRequest = axios.post(this.$api_url + '/leave-attendance/overtime-runs/' + this.run_id).then((response) => {
        this.month_label = response.data.month_label;
        this.year = response.data.year;
        this.run_approved = (response.data.status == 1);
      }).catch(() => {
      });

      const employeeRequest = this.company_options.length > 0 ? Promise.resolve() : this.fetchEmployees();

      const overtimeRequest = axios.post(this.$api_url + '/leave-attendance/overtime/preview', formData).then((response) => {
        this.overtimes = response.data || [];
      });

      Promise.all([runRequest, employeeRequest, overtimeRequest])
        .then(() => {
          this.selectedOvertimeRows = [];
          this.buildListRows();
          this.page_loader = false;
          this.loading = false;
        })
        .catch(() => {
          this.error_msg = 'Failed to load overtime data.';
          this.page_loader = false;
        });
    },

    confirmApprove() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to approve?', {
        title: 'Confirm Approval',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) return;
        this.approve_password = '';
        this.approve_error = '';
        this.$bvModal.show('overtime-approve-password-modal');
      });
    },
    confirmRevert() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to revert this run?', {
        title: 'Confirm',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) return;
        this.approve_password = '';
        this.approve_error = '';
        this.$bvModal.show('overtime-revert-password-modal');
      });
    },

    submitApprove(e) {
      e.preventDefault();
      if (!this.approve_password) {
        this.approve_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.approve_error = '';

      const formData = new FormData();
      formData.append('password', btoa(this.approve_password));

      axios.post(this.$api_url + '/leave-attendance/overtime-runs/' + this.run_id + '/approve', formData)
        .then((response) => {
          this.$bvToast.toast(response.data.message || 'Overtime run approved.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });
          this.run_approved = true;
          this.approve_password = '';
          this.loading = false;
          this.$bvModal.hide('overtime-approve-password-modal');
          this.fetchOvertimes();
        })
        .catch((error) => {
          this.serverError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    submitRevert(bvEvent) {
      bvEvent.preventDefault();
      if (!this.approve_password) {
        this.approve_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.approve_error = '';

      const formData = new FormData();
      formData.append('password', btoa(this.approve_password));

      axios.post(this.$api_url + '/leave-attendance/overtime-runs/' + this.run_id + '/revert', formData)
        .then(function (response) {
          this.$bvToast.toast(response.data.message || 'Overtime run reverted to draft.', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });
          this.run_approved = false;
          this.loading = false;
          this.approve_password = '';
          this.$bvModal.hide('overtime-revert-password-modal');
          this.fetchOvertimes();
        }.bind(this))
        .catch(function (error) {
          if (error.response && error.response.data && error.response.data.message) {
            this.approve_error = error.response.data.message;
          } else {
            this.approve_error = 'Failed to revert overtime run.';
          }
        }.bind(this))
        .finally(function () {
          this.loading = false;
        }.bind(this));
    },

    openDetailModal(row) {
      this.selectedDetailRow = row;
      this.overtimeDetails = [];
      this.selectAllFinal = false;
      this.detail_loading = true;
      this.loading = true;

      let formData = new FormData();
      formData.append('employee_id', row.employee_id);
      axios.post(this.$api_url + '/employee/setemployee', formData).then(_ => {
        this.$bvModal.show('overtime-detail-preview-modal');
        this.loading = false;
      })
    },

    confirmDeleteRun() {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this overtime run?', {
        title: 'Confirm Deletion',
        size: 'sm',
        okVariant: 'primary',
        okTitle: 'Yes',
        cancelTitle: 'No',
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(confirmed => {
        if (!confirmed) return;
        this.approve_password = '';
        this.approve_error = '';
        this.$bvModal.show('overtime-run-delete-password-modal');
      });
    },

    submitDeleteRun() {
      if (!this.approve_password) {
        this.approve_error = 'Password is required.';
        return;
      }

      this.loading = true;
      this.approve_error = '';

      const formData = new FormData();
      formData.append('password', btoa(this.approve_password));

      axios.post(this.$api_url + '/leave-attendance/overtime-runs/delete/' + this.run_id, formData)
        .then(() => {
          this.$bvModal.hide('overtime-run-delete-password-modal');
          window.location.href = this.$api_url + '/leave-attendance/overtime';
        })
        .catch((error) => {
          this.approve_error = (error.response && error.response.data && error.response.data.message)
            || 'Failed to delete overtime run.';
          this.loading = false;
        });
    },

    draftOvertime(data = null, flag) {
      if (flag == 1 && (!this.selectedOvertimeRows || this.selectedOvertimeRows.length == 0)) {
        this.$bvToast.toast("Select at least one row to approve.", {
          title: "Warning",
          variant: "warning",
          solid: true
        });
        return;
      }

      this._updateOvertimeStatus(data, flag, 'approve');
    },

    _updateOvertimeStatus(data, flag, action) {
      const verb = action === "settle" ? "approve" : "update";
      let msg = "";

      if (data != null) {
        msg = "Are you sure you want to approve overtime for " + data.name + "?";
      } else {
        msg = "Are you sure you want to approve overtime for selected employees?";
      }

      this.$bvModal.msgBoxConfirm(msg, {
        title: "Please Confirm",
        size: "sm",
        okVariant: "primary",
        okTitle: "Yes",
        cancelTitle: "Cancel",
        centered: true,
        bodyClass: "text-center",
        footerClass: "p-2 border-0 d-flex justify-content-center",
      }).then(value => {
        if (!value) {
          return;
        }

        try {
          const formData = new FormData();
          formData.append("action", action);
          formData.append("flg", 1);

          if (data == null) {
            if (flag == 1) {
              formData.append("overtime_id", JSON.stringify(this.selectedOvertimeRows));
            }
          } else {
            formData.append("overtime_id", JSON.stringify([data.id]));
          }

          this.loading = true;

          axios.post(this.$api_url + "/leave-attendance/overtime/update", formData)
            .then(response => {
              this.$bvToast.toast(response.data.message, {
                solid: true,
                title: "Success",
                variant: "success"
              });

              this.selectedOvertimeRows = [];
              this.fetchOvertimes();
            })
            .catch(e => {
              this.serverError(e);
              this.loading = false;
            });

        } catch (e) {
          this.serverError(e);
          this.loading = false;
        }
      });
    },
  },
}
</script>
